// extracted by mini-css-extract-plugin
export default {"title":"Qaa-z","warning":"Raa-z","sizeOptionsLegendText":"Saa-z"};